import { useRef } from "react";
import "@/App.css";
import HeroSection from "./components/sections/HeroSection";
import WhyPhyntexSection from "./components/sections/WhyPhyntexSection";
import HowItWorksSection from "./components/sections/HowItWorksSection";
import ProofWallSection from "./components/sections/ProofWallSection";
import CTASection from "./components/sections/CTASection";
import SociaBuzzSection from "./components/sections/SociaBuzzSection";
import { useGSAPAnimations } from "./hooks/useGSAPAnimations";
import { TELEGRAM_PM } from "./constants/links";

function App() {
  const mainRef = useRef(null);
  useGSAPAnimations(mainRef);

  return (
    <div ref={mainRef} data-testid="app-root">
      {/* Fixed video background */}
      <div className="fixed inset-0 z-0 overflow-hidden">
        <video
          id="bg-video"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover will-change-transform"
          poster="/assets/dp1.jpg"
          data-testid="hero-video"
          style={{ transformOrigin: "center center" }}
        >
          <source src="/assets/intro.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-[#050505]/75" />
      </div>

      {/* Fixed Navbar */}
      <nav
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-3 sm:px-5 md:px-8 py-3 md:py-4 nav-blur"
        data-testid="navbar"
      >
        <div className="flex items-center gap-2 sm:gap-2.5">
          <img
            src="/assets/dp1.jpg"
            alt="Asyrol"
            className="w-8 h-8 sm:w-9 sm:h-9 rounded-full object-cover border border-[#00FF88]/30"
            style={{ boxShadow: "0 0 10px rgba(0,255,136,0.2)" }}
            data-testid="logo-img"
          />
          <span className="font-teko text-sm sm:text-lg md:text-xl tracking-[0.10em] sm:tracking-[0.15em] text-[#F5F5F5] uppercase">
            HELLOASYROL
          </span>
        </div>
        <a
          href={TELEGRAM_PM}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta"
          className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 md:px-5 py-1.5 md:py-2 bg-[#00FF88] rounded-full text-[10px] sm:text-[11px] md:text-xs text-[#050505] hover:bg-[#00FF88]/90 transition-all font-inter tracking-wider uppercase font-bold"
          style={{ boxShadow: "0 0 15px rgba(0,255,136,0.4)" }}
        >
          JOIN NOW
        </a>
      </nav>

      {/* Sections */}
      <HeroSection />
      <SociaBuzzSection />
      <WhyPhyntexSection />
      <ProofWallSection />
      <HowItWorksSection />
      <CTASection />
    </div>
  );
}

export default App;
